import React from "react";

import { Loader } from "@editor/components/common/Loader";
import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";
import { productRouter } from "@editor/trpc/product";

import { ProductsTable } from "@/features/products/components/ProductsTable";
import { ProductsSetup } from "@/features/products/ProductsSetup";
import { skipToken } from "@tanstack/react-query";

export function ProductsDashboard() {
  const { project } = useCurrentProjectContext();
  const shopifyData = project?.integrations?.shopify?.store;
  const { data: products, isLoading: isLoadingProducts } =
    productRouter.list.useQuery(
      project?.id
        ? {
            projectId: project.id,
            limit: 1,
            writeThroughProductsSync: true,
          }
        : skipToken,
    );
  const shouldShowProductsSetup = Boolean(
    !shopifyData && (!products || products.products.length === 0),
  );

  if (isLoadingProducts) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col w-full h-full items-center">
      {shouldShowProductsSetup ? <ProductsSetup /> : <ProductsTable />}
    </div>
  );
}
